<template>
  <div>
    <v-card class="pa-6">
      <b>{{ $t('MANAGE.CONFIG.DEFAULT_PROJECT_PRIVACY') }}</b>
      <div class="pt-2" style="max-width: 360px;">
        <v-select v-model="defaultProjectPrivacy" :items="availablePrivacyOptions"></v-select>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.CATEGORY_COLORS') }}</b>
      <div class="pt-2">
        <manage-config-project-settings-categories v-if="showCategories"></manage-config-project-settings-categories>
        <v-btn v-else size="small" color="primary" variant="outlined" rounded class="mt-1" @click="showCategories = true">{{ $t('MANAGE.CONFIG.CUSTOM_CATEGORY_COLORS') }}</v-btn>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.VIRTUAL_PARTICIPANT', 2) }}</b>
      <div class="pt-1">
        <div class="d-flex gap-4 line-height-normal">
          <div style="flex: 1 1 50%; max-width: 360px;">
            <small>{{ $t('MANAGE.CONFIG.BUSINESS_PARTICIPANT_DESC') }}</small>
            <div class="d-flex mt-2 pr-2 overflow-y-auto overflow-x-hidden light-scrollbar" style="height: 144px">
              <div class="pt-3 pr-1">
                <manage-config-project-settings-participants-icons :text-users="computedConfig.businessTextUsers || []"></manage-config-project-settings-participants-icons>
              </div>
              <v-textarea v-model="textUsers" auto-grow class="textarea-nobr" @blur="updateTextUsers($event.target.value, true); $event.target.scrollLeft = 0"></v-textarea>
            </div>
          </div>
          <div v-if="clientConfigTextUsers" style="flex: 1 1 50%">
            <small><br>{{ $t('MANAGE.CONFIG.CLIENTCONFIG_PARTICIPANT_DESC') }}</small>
            <div class="d-flex mt-2 pr-2 overflow-y-auto overflow-x-hidden light-scrollbar" style="height: 144px">
              <div class="py-3 pr-1">
                <manage-config-project-settings-participants-icons :text-users="computedConfig.clientConfigTextUsers || []" readonly></manage-config-project-settings-participants-icons>
              </div>
              <v-textarea :model-value="clientConfigTextUsers" auto-grow readonly></v-textarea>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="mt-6 pa-6">
      <b>{{ $t('MANAGE.CONFIG.TASKS_CONTENT') }}</b>
      <v-btn-icon v-if="! elementDetailsDefautVisibleContent.isTaskDefault" :title="$t('MANAGE.CONFIG.RESET_DEFAULT')" class="float-end" size="x-small"
                  @click="taskVisibleContent = elementDetailsDefautVisibleContent.task">
        <v-icon>far fa-undo-alt</v-icon>
      </v-btn-icon>
      <div class="d-flex flex-wrap column-gap-4">
        <v-checkbox v-for="(textKey, item) in elementDetailsAvailableContents" :key="item"
                    v-model="taskVisibleContent" :value="item" density="compact">
          <template #label>{{ $t(textKey) }}</template>
        </v-checkbox>
      </div>
      <div class="py-2"></div>
      <b>{{ $t('MANAGE.CONFIG.MILESTONES_CONTENT') }}</b>
      <v-btn-icon v-if="! elementDetailsDefautVisibleContent.isMilestoneDefault" :title="$t('MANAGE.CONFIG.RESET_DEFAULT')" class="float-end" size="x-small"
                  @click="milestoneVisibleContent = elementDetailsDefautVisibleContent.milestone">
        <v-icon>far fa-undo-alt</v-icon>
      </v-btn-icon>
      <div class="d-flex flex-wrap column-gap-4">
        <v-checkbox v-for="(textKey, item) in elementDetailsAvailableContents" :key="item"
                    v-model="milestoneVisibleContent" :value="item" density="compact">
          <template #label>{{ $t(textKey) }}</template>
        </v-checkbox>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.SUBPROJECTS_DISPLAYED_CONTENT') }}</b>
      <div class="pt-2">
        <div class="d-flex flex-wrap column-gap-4">
          <v-checkbox v-model="subprojectsVisibleDetails" value="synthesis" density="compact">
            <template #label>{{ $t('MANAGE.CONFIG.SYNTHESIS') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="progress" density="compact">
            <template #label>{{ $t('ELEMENT-DETAIL.PROGRESS') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="process" density="compact">
            <template #label>{{ $t('KANBAN.STEP') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="subTasks" density="compact">
            <template #label>{{ $t('ELEMENT-DETAIL.MACRO.SUB_TASKS') }}</template>
          </v-checkbox>
        </div>
        <div class="d-flex flex-wrap column-gap-4">
          <v-checkbox v-model="subprojectsVisibleDetails" value="date" density="compact">
            <template #label>{{ $t('MANAGE.CONFIG.MILESTONE_DATE') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="dates" density="compact">
            <template #label>{{ $t('MANAGE.CONFIG.TASK_DATES') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="links" density="compact">
            <template #label>{{ $t('ELEMENT-DETAIL.ATTACHMENTS') }}</template>
          </v-checkbox>
          <v-checkbox v-model="subprojectsVisibleDetails" value="budgets" density="compact">
            <template #label>{{ $t('ELEMENT-DETAIL.BUDGET') }}</template>
          </v-checkbox>
        </div>
        <v-switch v-model="subprojectsSynthesisPopover" :disabled="! subprojectsVisibleDetails.includes('synthesis')">
          <template #label>{{ $t('MANAGE.CONFIG.DISPLAY_SYNTHESIS_POPOVER') }}</template>
        </v-switch>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.AUTO_AFFECTATION') }}</b>
      <div class="pt-2">
        <v-switch v-model="assignBubblesToCreator">
          <template #label>{{ $t('MANAGE.CONFIG.ASSIGN_BUBBLES_TO_CREATOR') }}</template>
        </v-switch>
      </div>
      <div>
        <v-switch v-model="assignActionsToCreator">
          <template #label>{{ $t('MANAGE.CONFIG.ASSIGN_ACTIONS_TO_CREATOR') }}</template>
        </v-switch>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.DEPENDENCIES') }}</b>
      <div class="pt-2">
        <v-switch v-model="dependencyTypes">
          <template #label>{{ $t('MANAGE.CONFIG.DEPENDENCY_TYPES') }}</template>
        </v-switch>
      </div>
    </v-card>
    <v-card class="mt-6 pa-6">
      <b>{{ $t('HR.WORKLOAD') }}</b>
      <div class="pt-2 d-flex align-center">
        <v-switch v-model="workloadInHours" class="mr-2 flex-grow-0">
          <template #label>{{ $t('MANAGE.CONFIG.DISPLAY_WORKLOAD_IN_HOURS') }}</template>
        </v-switch>
        <div class="ml-4">
          <v-text-field v-model.number="workloadHoursPerDay" :disabled="! workloadInHours"
                        :label="$t('MANAGE.CONFIG.NUMBER_OF_HOURS')" :title="$t('MANAGE.CONFIG.NUMBER_OF_HOURS')"
                        type="number" step="any" min="0" :max="maxHoursPerDay"
                        @change="setParam('workloadHoursPerDay', workloadHoursPerDay)">
          </v-text-field>
        </div>
      </div>
      <div class="py-4"></div>
      <b>{{ $t('MANAGE.CONFIG.BUSINESS_HOURS') }}</b>
      <div class="pt-1"><small>{{ $t('MANAGE.CONFIG.BUSINESS_HOURS_DESC') }}</small></div>
      <div class="pt-2 d-flex align-center">
        <v-switch v-model="activateBusinessHours" class="mr-2 flex-grow-0">
          <template #label>{{ $t('MANAGE.CONFIG.ACTIVATE_BUSINESS_HOURS') }}</template>
        </v-switch>
        <div class="ml-4">
          <v-text-field v-model.number="businessHoursStart" :disabled="! activateBusinessHours" :label="$t('ELEMENT-DETAIL.SCHEDULE_START')"
                        type="number" step="any" min="0" max="24"
                        @change="updateBusinessHours">
          </v-text-field>
        </div>
        <div class="ml-4">
          <v-text-field v-model.number="businessHoursEnd" :disabled="! activateBusinessHours" :label="$t('ELEMENT-DETAIL.SCHEDULE_END')"
                        type="number" step="any" min="0" max="24"
                        @change="updateBusinessHours">
          </v-text-field>
        </div>
      </div>
    </v-card>
    <v-card class="mt-6 pa-6">
      <b>{{ $t('MANAGE.CONFIG.BUDGET_STATE', 2) }}</b>
      <div class="pt-2">
        <manage-config-project-settings-budget></manage-config-project-settings-budget>
      </div>
    </v-card>
    <manage-config-palette class="mt-6"></manage-config-palette>
  </div>
</template>

<style lang="scss">
  .textarea-nobr textarea {
    white-space: pre;
    overflow: hidden;
  }
</style>

<script>
  import defaultConfig from '@/js/defaultConfig';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import ManageConfigProjectSettingsCategories from './ManageConfigProjectSettingsCategories.vue';
  import ManageConfigProjectSettingsParticipantsIcons from './ManageConfigProjectSettingsParticipantsIcons.vue';
  import ManageConfigProjectSettingsBudget from './ManageConfigProjectSettingsBudget.vue';
  import ManageConfigPalette from './ManageConfigPalette.vue';

  export default {
    components: {
      ManageConfigProjectSettingsCategories,
      ManageConfigProjectSettingsParticipantsIcons,
      ManageConfigProjectSettingsBudget,
      ManageConfigPalette,
    },
    data() {
      return {
        maxHoursPerDay: 24,
        workloadHoursPerDay: null,
        businessHoursStart: null,
        businessHoursEnd: null,
        availablePrivacyOptions: defaultConfig.availablePrivacyOptions(),
        showCategories: false,
        elementDetailsAvailableContents: {
          checklist: 'ELEMENT-DETAIL.CHECKLIST',
          progress: 'ELEMENT-DETAIL.PROGRESSION',
          users: 'ELEMENT-DETAIL.USERS',
          links: 'ELEMENT-DETAIL.ATTACHMENTS',
          alerts: 'ELEMENT-DETAIL.ALERTS',
          budgets: 'ELEMENT-DETAIL.BUDGET',
          comments: 'ELEMENT-DETAIL.COMMENTS',
        },
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      defaultProjectPrivacy: {
        get() {
          return this.computedConfig.defaultProjectPrivacy;
        },
        set(newVal) {
          this.setParam('defaultProjectPrivacy', newVal);
        },
      },
      textUsers: {
        get() {
          return (this.computedConfig.businessTextUsers || []).join("\n");
        },
        set(newVal) {
          this.updateTextUsers(newVal);
        },
      },
      clientConfigTextUsers() {
        return (this.computedConfig.clientConfigTextUsers || []).join("\n");
      },
      elementDetailsAvailableContentsKeys() {
        return Object.keys(this.elementDetailsAvailableContents);
      },
      taskVisibleContent: {
        get() {
          // display visible content keys in the interface
          return _.difference(this.elementDetailsAvailableContentsKeys, this.computedConfig.elHiddenContent.task);
        },
        set(newVal) {
          // save hidden content keys
          this.setParam('elHiddenContent', { ...this.computedConfig.elHiddenContent, task: _.difference(this.elementDetailsAvailableContentsKeys, newVal) });
        },
      },
      milestoneVisibleContent: {
        get() {
          return _.difference(this.elementDetailsAvailableContentsKeys, this.computedConfig.elHiddenContent.milestone);
        },
        set(newVal) {
          this.setParam('elHiddenContent', { ...this.computedConfig.elHiddenContent, milestone: _.difference(this.elementDetailsAvailableContentsKeys, newVal) });
        },
      },
      elementDetailsDefautVisibleContent() {
        const task = this.elementDetailsAvailableContentsKeys.slice();
        const milestone = _.difference(this.elementDetailsAvailableContentsKeys, ['checklist', 'progress', 'budgets']);
        return {
          task,
          isTaskDefault: _.isEqual(task, this.taskVisibleContent), // assumes vuetify checkbox model preserves order
          milestone,
          isMilestoneDefault: _.isEqual(milestone, this.milestoneVisibleContent),
        };
      },
      subprojectsVisibleDetails: {
        get() {
          return this.computedConfig.subprojectsVisibleDetails;
        },
        set(newVal) {
          this.setParam('subprojectsVisibleDetails', newVal);
        },
      },
      subprojectsSynthesisPopover: {
        get() {
          return this.computedConfig.subprojectsSynthesisPopover;
        },
        set(newVal) {
          this.setParam('subprojectsSynthesisPopover', newVal);
        },
      },
      assignBubblesToCreator: {
        get() {
          return this.computedConfig.assignBubblesToCreator;
        },
        set(newVal) {
          this.setParam('assignBubblesToCreator', newVal);
        },
      },
      assignActionsToCreator: {
        get() {
          return this.computedConfig.assignActionsToCreator;
        },
        set(newVal) {
          this.setParam('assignActionsToCreator', newVal);
        },
      },
      dependencyTypes: {
        get() {
          return this.computedConfig.dependencyTypes;
        },
        set(newVal) {
          this.setParam('dependencyTypes', newVal);
        },
      },
      workloadInHours: {
        get() {
          return this.computedConfig.workloadInHours;
        },
        set(newVal) {
          this.setParam('workloadInHours', newVal);
        },
      },
      activateBusinessHours: {
        get() {
          return !! this.computedConfig.businessHours;
        },
        set(newVal) {
          if (newVal) {
            this.updateBusinessHours();
          } else {
            this.setParam('businessHours', null);
          }
        },
      },
      computedConfig() {
        return this.usersAccessRightStore.config;
      },
      clientConfig() {
        return this.usersAccessRightStore.clientConfig;
      },
    },
    watch: {
      workloadHoursPerDay(newVal) {
        if (newVal > this.maxHoursPerDay) this.$nextTick(() => { this.workloadHoursPerDay = this.maxHoursPerDay; });
      },
      'computedConfig.businessHours.start': {
        handler(newVal) { this.businessHoursStart = (typeof newVal == 'number') ? newVal / 60 : 7; },
        immediate: true,
      },
      'computedConfig.businessHours.end': {
        handler(newVal) { this.businessHoursEnd = (typeof newVal == 'number') ? newVal / 60 : 19; },
        immediate: true,
      },
    },
    created() {
      this.workloadHoursPerDay = this.computedConfig.workloadHoursPerDay;

      this.debounceSetTextUsers = _.debounce(function (val) {
        this.setParam('textUsers', val);
      }, 5000);
    },
    methods: {
      updateBusinessHours() {
        if (! this.activateBusinessHours) this.setParam('businessHours', null);
        let start = Math.max(Math.min(this.businessHoursStart, this.businessHoursEnd), 0);
        let end = Math.min(Math.max(this.businessHoursStart, this.businessHoursEnd), 24);
        if (end - start < 1) { // 1 hour minimum gap
          end = Math.min(start + 1, 24);
          start = end - 1;
        }
        this.setParam('businessHours', { start: start * 60, end: end * 60 });
      },
      updateTextUsers(newVal, immediate = false) {
        if (newVal == this.textUsers) return;
        const textUsersTab = newVal.split('\n').map(item => item.trim()).filter(item => item);
        if (immediate || textUsersTab.length != (this.computedConfig.businessTextUsers?.length || 0)) {
          this.debounceSetTextUsers.cancel();
          this.setParam('textUsers', textUsersTab.length ? textUsersTab : null);
        } else {
          this.debounceSetTextUsers(textUsersTab.length ? textUsersTab : null); // debounce when editing text line
        }
      },
      setParam(prop, val) {
        this.usersAccessRightStore.updateBusinessConfig({ [prop]: val });
      },
    },
  };
</script>
